export const MARKET_ANALYSIS_NAV_CONFIG = [
	{
		name: 'apvendor-database',
		label: 'Vendor Database',
		path: '/market-analysis/vendor-database',
		lastRoute: 'vendor-database',
	},
	{
		name: 'suplier-diversity-database',
		label: 'Supplier Diversity Database',
		path: '/market-analysis/suplier-diversity-database',
		lastRoute: 'suplier-diversity-database',
	},
];
